














































import TextLabel from "@/common/components/atoms/TextLabel.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";

import JMessageArticlePanelBody from "@/general/components/pages/parts/ThanksPointList/JMessageArticlePanelBody.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import auth from "@/general/store/modules/auth";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
@Component({
  name: "JMessageArticlePanel",
  components: {
    TextLabel,
    PointNotation,
    SmallText,
    IconUserImage,
    JMessageArticlePanelBody,
    TextLabelNewArrivalCount
  }
})
export default class JMessageArticlePanel extends Vue {
  @Prop({ type: Object, required: true }) messageArticleDetail!: Record<
    string,
    any
  >;
  @Prop({ type: Array, required: true }) exclude!: any;

  textLabel = {
    send: {
      text: "送付",
      style: {
        border: "#ffffff",
        content: commons.colorCode
      }
    },
    receive: {
      text: "受取",
      style: {
        border: commons.colorCode,
        content: "#ffffff"
      }
    },
    customStyle: {
      width: "100%",
      minWidth: "100%"
    }
  };
  get date() {
    const getDate = new Date(this.messageArticleDetail.date);
    const UTCDate = getDate.toUTCString();
    const timeStamp = Date.parse(UTCDate);
    const ConvertDate = new Date(timeStamp);
    // const parsedDate = ConvertDate.toLocaleDateString();
    const parsedDate =
      ConvertDate.getFullYear() +
      "/" +
      ("0" + (ConvertDate.getMonth() + 1)).slice(-2) +
      "/" +
      ConvertDate.getDate();
    return parsedDate;
  }

  get url() {
    return this.messageArticleDetail.url;
  }

  get icon() {
    return this.messageArticleDetail.icon.medium;
  }

  get name() {
    return this.messageArticleDetail.name;
  }

  get content() {
    return this.messageArticleDetail.content;
  }

  get point() {
    return this.messageArticleDetail.point;
  }

  get sign() {
    return this.messageArticleDetail.point.state == "sent" ? false : true;
  }

  get textLabelObj() {
    const state = this.messageArticleDetail.point.state;
    if (state === "sent") {
      return this.textLabel.send;
    } else if (state === "received") {
      return this.textLabel.receive;
    } else {
      return this.textLabel.customStyle;
    }
  }

  get unread() {
      return this.messageArticleDetail.unread;
  }
  
  get unreadTotalCount() {
      const total = this.messageArticleDetail.unread_count;
      return total >= 10 ? "..." : total;
  }
  get UnreadCountisExist() {
	  return this.messageArticleDetail.unread_count	> 0 ? true : false;
  }

  get detailData() {
    const {
      content,
      date,
      icon,
      id,
      user_id,
      name,
      point,
      url,
      unreadCount
    } = this.messageArticleDetail;

    return {
      content,
      date,
      icon,
      id,
      user_id,
      name,
      point,
      url,
      unreadCount: unreadCount
    };
  }

  get headerIsExists() {
    const exclude = this.exclude;
    const isExclude = exclude.includes("header");
    return !isExclude;
  }

  get unreadCountIsExists() {
    const exclude = this.exclude;
    const isExclude = exclude.includes("unreadCount");
    return !isExclude;
  }

  get pointIsExists() {
    const exclude = this.exclude;
    const isExclude = exclude.includes("point");
    return !isExclude;
  }

  getMessageDetails() {
    localStorage.setItem(
      "messageCardDetails",
      JSON.stringify(this.messageArticleDetail)
    );
    window.location.href = this.url;
  }

  get messsageThreadEnabled() {
    return auth.user.thread_enabled;
  }
}
